import { Invoiceable, InvoiceLine, Tax, Party , ExtraAmount, RectificativeInfo, Invoice, Budget, DeliveryNote, Proforma, RecInv} from "@/modules/facturae/domain/Invoiceable";
import { InvoiceableRepository } from "@/modules/facturae/domain/InvoiceableRepository";
import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { query_dispatcher_get, sync_command_dispatcher, async_command_dispatcher } from "@/api/client";
import axios from "axios";
import { EmailTemplate } from "../domain/Configuration";

export function objectToDict(obj: any): Record<string, any> {
    const dict: Record<string, any> = {};

    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const value = obj[key];
            if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                // Recursively convert nested object
                dict[key] = objectToDict(value);
            } else {
                dict[key] = value;
            }
        }
    }

    return dict;
}

export function dataToLines(data): InvoiceLine[] {
    let lines = []
    if (data.invoice_lines) {
        lines = data.invoice_lines.map(line => 
            new InvoiceLine(
                line.description, 
                line.quantity, 
                line.unit_price_without_tax, 
                line.total_cost, 
                line.gross_amount, 
                line.taxes.map(tax => new Tax(tax.rate, tax.base, tax.amount, tax.recargo_rate, tax.recargo_amount)),
                line.taxes_withheld.map(tax => new Tax(tax.rate, tax.base, tax.amount)), 
                line.id, 
                null, 
                null, 
                null, 
                line.product_code, 
                null, 
                line.special_taxable_event,
                line.additional_information,
                    line.discounts.map(d => new ExtraAmount(d.reason, d.amount, d.rate))
            )
        );
        for(let line in lines){
            lines[line].selected_retention = 'na'
            if (lines[line].taxes_withheld.length > 0){
                lines[line].selected_retention = lines[line].taxes_withheld[0].rate //autocomplete selected retention
            }
            lines[line].selected_tax = lines[line].taxes[0].rate //autocomplete selected tax
            if (lines[line].taxes[0].recargo_rate){
                lines[line].selected_tax = lines[line].taxes[0].recargo_rate
            }
            lines[line].selected_tax_event = 'N/A'
            if (lines[line].special_taxable_event){
                let code = lines[line].special_taxable_event.code
                if (code == '01'){
                    if (lines[line].special_taxable_event.reason.includes('sujeto pasivo')){
                        lines[line].selected_tax_event = 'ISP'
                    }
                    else if(lines[line].special_taxable_event.reason.includes('intracomunitaria')){
                        lines[line].selected_tax_event = 'INTRA.'
                    }
                    else if(lines[line].special_taxable_event.reason.includes('exportaci')){
                        lines[line].selected_tax_event = 'EXPORT.'
                    }
                    else if(lines[line].special_taxable_event.reason.includes('exent')){
                        lines[line].selected_tax_event = 'EX'
                    }
                }
                else if (code == '02'){
                    lines[line].selected_tax_event = 'NS'
                }
            }
        }
        lines.sort((a, b) => {
            if (a.id === undefined && b.id === undefined) return 0; // Ambos no tienen ID, no cambiar su orden
            if (a.id === undefined) return 1; // 'a' no tiene ID, mover al final
            if (b.id === undefined) return -1; // 'b' no tiene ID, mover al final
            return a.id - b.id; // Ambos tienen ID, ordenar por ID
            });
    }
    return lines
}

export function dataToParty(data:any, customer:boolean): Party {
    let party =  new Party(
        data.id,
        data.company_id,
        data.cif,
        data.post_code,
        data.type,
        data.name,
        data.first_surname,
        data.second_surname,
        data.business_name,
        data.trade_name,
        data.address,
        data.city,
        data.province,
        data.email,
        data.phone,
        data.website,
        null,
        null,
        null,
        null,
        data.bank_account_number,
        data.bic
    )
    if (customer) {
        party.DIRe = data.DIRe
        party.accounting_office = data.accounting_office
        party.management_body = data.management_body
        party.processing_unit = data.processing_unit
        party.proposing_body = data.proposing_body
        party.mandate_id = data.mandate_id
        party.mandate_signature_date = data.mandate_signature_date
    }
    return party
}

export class ApiInvoiceableRepository implements InvoiceableRepository {

    command_dispatcher: CommandDispatcher
    query_dispatcher: QueryDispatcher
    async_command_dispatcher: CommandDispatcher
    constructor() {
        this.command_dispatcher = sync_command_dispatcher
        this.query_dispatcher = query_dispatcher_get
        this.async_command_dispatcher = async_command_dispatcher
    }
    // tax(rate: number, base: number, amount: number) {
    // line(description: string, quantity: number, unit_price_without_tax: number, total_cost: number, gross_amount: number, taxes: Tax[], id?: number) {
    // inv(id: number, total_amount: number, invoice_lines: InvoiceLine[], other_amounts?: number) {
    api_to_domain(inv_data) {
        let lines = dataToLines(inv_data)
        let discounts = []
        if (inv_data.general_discounts){
            discounts = inv_data.general_discounts.map(discount => new ExtraAmount(discount.reason, discount.amount, discount.rate))
        }
        let supplier = null
        if (inv_data.supplier) {
            supplier = dataToParty(inv_data.supplier, false)
        }
        let customer = null
        if (inv_data.customer) {
            customer = dataToParty(inv_data.customer, true)
        }

        if (inv_data.type == 'budget') {
            return new Budget(
                inv_data.id,
                inv_data.company_id,
                inv_data.total_amount,
                inv_data.total_to_pay,
                inv_data.invoice_number,
                inv_data.invoice_date,
                lines,
                inv_data.other_amounts,
                supplier,
                customer,
                inv_data.state,
                inv_data.invoice_due_date,
                inv_data.external_invoice_number,
                inv_data.start_date,
                inv_data.end_date,
                inv_data.retention_concept,
                inv_data.retention_amount!=0?inv_data.retention_amount:undefined,
                inv_data.kind,
                0,
                0,
                0,
                0,
                0,
                [],
                [],
                discounts,
                [],
                inv_data.reimbursable_amounts,
                inv_data.signing_time,
                inv_data.sequence_id,
                inv_data.predicted_invoice_number,
                inv_data.payment_state,
                inv_data.accounting_document_id,
                inv_data.rectificative,
                null,
                inv_data.predicted_rectificative_invoice_number,
                inv_data.tax_type,
                inv_data.additional_info,
                inv_data.free_notes,
                null,
            )
        } else if (inv_data.type === 'delivery_note') {
            return new DeliveryNote(
                inv_data.id,
                inv_data.company_id,
                inv_data.total_amount,
                inv_data.total_to_pay,
                inv_data.invoice_number,
                inv_data.invoice_date,
                lines,
                inv_data.other_amounts,
                supplier,
                customer,
                inv_data.state,
                inv_data.invoice_due_date,
                inv_data.external_invoice_number,
                inv_data.start_date,
                inv_data.end_date,
                inv_data.retention_concept,
                inv_data.retention_amount!=0?inv_data.retention_amount:undefined,
                inv_data.kind,
                0,
                0,
                0,
                0,
                0,
                [],
                [],
                discounts,
                [],
                inv_data.reimbursable_amounts,
                inv_data.signing_time,
                inv_data.sequence_id,
                inv_data.predicted_invoice_number,
                inv_data.payment_state,
                inv_data.accounting_document_id,
                inv_data.rectificative,
                null,
                inv_data.predicted_rectificative_invoice_number,
                inv_data.tax_type,
                inv_data.additional_info,
                inv_data.free_notes,
                null,
            )
        } else if (inv_data.type === 'proforma') {
            return new Proforma(
                inv_data.id,
                inv_data.company_id,
                inv_data.total_amount,
                inv_data.total_to_pay,
                inv_data.invoice_number,
                inv_data.invoice_date,
                lines,
                inv_data.other_amounts,
                supplier,
                customer,
                inv_data.state,
                inv_data.invoice_due_date,
                inv_data.external_invoice_number,
                inv_data.start_date,
                inv_data.end_date,
                inv_data.retention_concept,
                inv_data.retention_amount!=0?inv_data.retention_amount:undefined,
                inv_data.kind,
                0,
                0,
                0,
                0,
                0,
                [],
                [],
                discounts,
                [],
                inv_data.reimbursable_amounts,
                inv_data.signing_time,
                inv_data.sequence_id,
                inv_data.predicted_invoice_number,
                inv_data.payment_state,
                inv_data.accounting_document_id,
                inv_data.rectificative,
                null,
                inv_data.predicted_rectificative_invoice_number,
                inv_data.tax_type,
                inv_data.additional_info,
                inv_data.free_notes,
                null,
            )
        }
         else if (inv_data.type === 'recurring_invoice_contract') {
            return new RecInv(
                inv_data.id,
                inv_data.company_id,
                inv_data.total_amount,
                inv_data.total_to_pay,
                '',
                '',
                lines,
                inv_data.other_amounts,
                supplier,
                customer,
                '',
                '',
                '',
                '',
                '',
                inv_data.retention_concept,
                inv_data.retention_amount!=0?inv_data.retention_amount:undefined,
                inv_data.kind,
                0,
                0,
                0,
                0,
                0,
                [],
                [],
                discounts,
                [],
                inv_data.reimbursable_amounts,
                '',
                inv_data.sequence_id,
                inv_data.predicted_invoice_number,
                '',
                null,
                false,
                null,
                '',
                inv_data.tax_type,
                inv_data.additional_info,
                '',
                inv_data.payment_means,
                inv_data.recurring_invoice_contract_id,
                inv_data.is_for_recurring_contracts,
                inv_data.related_invoiceable_ids
            )
        } else {
            let rectificative_info = null
            if (inv_data.rectificative && inv_data.rectificative_info){
                rectificative_info = new RectificativeInfo(inv_data.rectificative_info.reason, inv_data.rectificative_info.invoice_id, inv_data.rectificative_info.invoice_number, inv_data.rectificative_info.invoice_date)
            }
            return new Invoice(
                inv_data.id,
                inv_data.company_id,
                inv_data.total_amount,
                inv_data.total_to_pay,
                inv_data.invoice_number,
                inv_data.invoice_date,
                lines,
                inv_data.other_amounts,
                supplier,
                customer,
                inv_data.state,
                inv_data.invoice_due_date,
                inv_data.external_invoice_number,
                inv_data.start_date,
                inv_data.end_date,
                inv_data.retention_concept,
                inv_data.retention_amount!=0?inv_data.retention_amount:undefined,
                inv_data.kind,
                0,
                0,
                0,
                0,
                0,
                [],
                [],
                discounts,
                [],
                inv_data.reimbursable_amounts,
                inv_data.signing_time,
                inv_data.sequence_id, 
                inv_data.predicted_invoice_number,
                inv_data.payment_state,
                inv_data.accounting_document_id,
                inv_data.rectificative,
                rectificative_info,
                inv_data.predicted_rectificative_invoice_number,
                inv_data.tax_type,
                inv_data.additional_info,
                inv_data.free_notes,
                inv_data.payment_means,
                null,
                inv_data.is_from_recurring_contract
            )
        }
    }
    domain_to_api(inv) {
        let data = JSON.parse(JSON.stringify(objectToDict(inv)));
        data['invoice_lines'] = [...data['lines']]
        delete data['lines']
        delete data['related_invoiceable_ids']
        for(let line in data['invoice_lines']){
            delete data['invoice_lines'][line]['selected_retention']
            delete data['invoice_lines'][line]['selected_tax']
        }
        if (data['retention_amount'] == ''){
            data['retention_amount'] = null
        }
        return data
    }

    async duplicate_as_draft(ids: Array<number>): Promise<any> {
        let res = await this.command_dispatcher.dispatch('duplicate.as.draft', { inv_ids: ids })
        return res.output
    }
    async send_to_accounting(ids: Array<number>): Promise<any> {
        return await this.async_command_dispatcher.dispatch('send.invoices.to.accounting', { inv_ids: ids })
    }
    async generate_invoice_from_invoiceable(ids: Array<number>): Promise<any> {
        let res = await this.command_dispatcher.dispatch('generate.invoice.from.invoiceable', { invoiceables_ids: ids })
        return res.output
    }
    async generate_remitance(ids: Array<number>): Promise<any> {
        let res = await this.command_dispatcher.dispatch("generate.invoices.remittance", { inv_ids: ids })
        return res.output
    }
    async find_by_id(id): Promise<Invoiceable | null> {
        let inv_data = await this.query_dispatcher.dispatch('get.static.invoice', { inv_id: id })
        if (inv_data){
            return this.api_to_domain(inv_data)
        }
        return null
    }

    async filter_invoices(args): Promise<{results: Invoiceable[], count: number}> {
        let inv_data = await this.query_dispatcher.dispatch('get.facture.e.list', args)
        let count = inv_data.count
        inv_data = inv_data.results || []
        let inv_list = []
        for (let inv in inv_data) {
            inv_list.push(this.api_to_domain(inv_data[inv]))
        }
        if(!count){
            count = inv_list.length
        }
        return {results:inv_list, count: count}
    }

    async save(inv) {
        let inv_data = this.domain_to_api(inv)
        let command = 'save.invoice'
        if (inv.type == 'budget') {
            command = 'save.budget'
        } else if (inv.type == 'delivery_note') {
            command = 'save.delivery_note'
        } else if (inv.type == 'proforma') {
            command = 'save.proforma'
        }
        let res = await this.command_dispatcher.dispatch(command, { inv: inv_data })
        return res['output']['inv_id']
    }

    async import_lines_from_excel(id, path) {
        await this.command_dispatcher.dispatch('import.lines.from.excel', { inv_id: id, excel_path: path })
    }

    async mock_find_by_id(id): Promise<Invoiceable | null> {

        return new Invoiceable(1, 200, 605, 605, "2020/0001", "2020-01-01", [
            new InvoiceLine("line 1", 1, 100, 100, 100, [new Tax(0.21, 100, 21)], [],1),
            new InvoiceLine("line 2", 1, 100, 100, 100, [new Tax(0.21, 100, 21)], [],2),
            new InvoiceLine("line 3", 1, 100, 100, 100, [new Tax(0.21, 100, 21)], [],3),
            new InvoiceLine("line 4", 1, 100, 100, 100, [new Tax(0.21, 100, 21)], [],4),
            new InvoiceLine("line 5", 1, 100, 100, 100, [new Tax(0.21, 100, 21)], [],5),
        ], 0, new Party(1, 200,"12345678Z", "12345", null, "Supplier", "Supplier last name", null, null , "Supplier address", "Supplier city", "Supplier province"), new Party(2, 200,"12345678Z", "12345","fisica", "Customer name",  "Customer last name", "Customer address", "Customer city", "Customer province"))
    }

    supplier_from_current_company(currentCompany) {
        let supplier = new Party(0, currentCompany.id, "", "", "juridica", "", "", "","","", "", "")
        if (currentCompany.configuration && currentCompany.configuration.company_as_party){
            let cap = currentCompany.configuration.company_as_party
            supplier.business_name = cap.business_name ? cap.business_name : ""
            supplier.trade_name = cap.trade_name ? cap.trade_name : ""
            supplier.name = cap.name ? cap.name : ""
            supplier.first_surname = cap.first_surname ? cap.first_surname : ""
            supplier.second_surname = cap.second_surname ? cap.second_surname : ""
            supplier.type = cap.type
            supplier.cif = cap.cif
            supplier.address = cap.address
            supplier.city = cap.city
            supplier.province = cap.province
            supplier.email = cap.email
            supplier.phone = cap.phone
            supplier.website = cap.website
            supplier.post_code = cap.post_code
            supplier.bank_account_number = cap.bank_account_number
            supplier.bic = cap.bic
        }
        return supplier
    }

    create_empty_invoiceable(company_id, currentCompany, next_number, next_rectificative_number, tax_type = 'iva', invoiceable_type='invoice') {
        let first_tax = 0.21
        if(!tax_type.includes('iva') && tax_type.includes('igic')){
            first_tax = 0.07
        }
        let empty_line = new InvoiceLine("", 0, 0, 0, 0, [new Tax(first_tax, 0, 0)])
        empty_line.selected_tax = first_tax
        empty_line.discounts = [new ExtraAmount('Descuento', 0, 0)]
        let supplier = null
        let si = null;
        if (currentCompany) {
            supplier = this.supplier_from_current_company(currentCompany)
        } else{
            supplier = new Party(0, company_id, "", "", "juridica", "", "", "","","", "", "")
        }
        let today_date = new Date().toISOString().split('T')[0]
        if (invoiceable_type == 'budget') {
            si = new Budget(null, company_id, 0, 0, "", today_date, [empty_line], 0, supplier, new Party(0, company_id, "", "", "juridica", "", "", "","","", "", ""))
        } else if (invoiceable_type === 'delivery_note') {
            si = new DeliveryNote(null, company_id, 0, 0, "", today_date, [empty_line], 0, supplier, new Party(0, company_id, "", "", "juridica", "", "", "","","", "", ""))
        } else if (invoiceable_type === 'proforma') {
            si = new Proforma(null, company_id, 0, 0, "", today_date, [empty_line], 0, supplier, new Party(0, company_id, "", "", "juridica", "", "", "","","", "", ""))
        } else if (invoiceable_type === 'recurring_invoice_contract') {
            si = new RecInv(null, company_id, 0, 0, "", today_date, [empty_line], 0, supplier, new Party(0, company_id, "", "", "juridica", "", "", "","","", "", ""), '')
        } else {
            si = new Invoice(null, company_id, 0, 0, "", today_date, [empty_line], 0, supplier, new Party(0, company_id, "", "", "juridica", "", "", "","","", "", ""), 'draft', today_date)
        }
        si.predicted_invoice_number = next_number
        si.predicted_rectificative_invoice_number = next_rectificative_number
        if (tax_type == 'igic'){
            si.tax_type = 'igic'
        }
        else{
            si.tax_type = 'iva'
        }
        
        return si
    }

    async download_xml(id) {
        return await this.async_command_dispatcher.dispatch('create.xml.from.invoice', { inv_id: id })
    }

    async download_pdf(id: any): Promise<any> {
        return await this.async_command_dispatcher.dispatch('downalod_e_invoice_pdf', { inv_id: id, force_download: true })

    }

    async download_pdfs(ids: Array<any>): Promise<any> {
        return await this.async_command_dispatcher.dispatch('massive.download.pdfs', { inv_ids: ids })

    }

    async sign(id): Promise<boolean> {
        let res = await this.command_dispatcher.dispatch("sign.static.invoice.xml", { inv_id: id })
        if (res.output.error) {
            return false
        }
        else {
            return true
        }
    }

    async issue(id): Promise<boolean> {
        let res = await this.command_dispatcher.dispatch("issue.invoiceable", { inv_id: id })
        if (res.output.status === 'error') {
            return false
        }
        else {
            return true
        }
    }

    async unsign(id): Promise<boolean> {
        try{
            let res = await this.command_dispatcher.dispatch("unsign.invoice", { inv_id: id })
            if (res.output.error) {
                return false
            }
            else {
                return true
            }
        }
        catch(e){
            return false
        }
        
    }

    async send(id, send_to): Promise<any> {
        return await this.async_command_dispatcher.dispatch("send.factura.e.xml", { inv_id: id, send_to:send_to })
    }

    async send_invoice_email(id, email): Promise<any> {
        let args = { inv_id: id, to: email.to , subject: email.subject, body: email.body }
        return await this.async_command_dispatcher.dispatch("send.invoice.via.mail", args)
    }

    async send_invoice_accounting(id) : Promise<any> {
        return await this.async_command_dispatcher.dispatch("send.invoice.to.accounting", { inv_id: id })
    }

    async get_customer_list(company_id:string|number): Promise<Party[]> {
        let res = await this.query_dispatcher.dispatch('get.facture.e.customers', { company_id: company_id})
        let customerList = [new Party(-1, company_id, "", "", "", "", "", "", "", "", "", "")]
        if (res) {
            for (let customer in res) {
                let emptyParty = new Party(0, res[customer].company_id, "", "", "", "", "", "", "", "", "", "") 
                emptyParty.id = res[customer].id
                emptyParty.cif = res[customer].cif
                emptyParty.post_code = res[customer].post_code
                emptyParty.type = res[customer].type
                emptyParty.name = res[customer].name
                emptyParty.first_surname = res[customer].first_surname
                emptyParty.second_surname = res[customer].second_surname
                emptyParty.business_name = res[customer].business_name
                emptyParty.trade_name = res[customer].trade_name
                emptyParty.address = res[customer].address
                emptyParty.city = res[customer].city
                emptyParty.province = res[customer].province
                emptyParty.email = res[customer].email
                emptyParty.phone = res[customer].phone
                emptyParty.website = res[customer].website
                emptyParty.DIRe = res[customer].DIRe
                emptyParty.accounting_office = res[customer].accounting_office
                emptyParty.management_body = res[customer].management_body
                emptyParty.processing_unit = res[customer].processing_unit
                emptyParty.proposing_body = res[customer].proposing_body
                emptyParty.bank_account_number = res[customer].bank_account_number
                emptyParty.bic = res[customer].bic
                emptyParty.mandate_id = res[customer].mandate_id
                emptyParty.mandate_signature_date = res[customer].mandate_signature_date
                emptyParty.debit_account = res[customer].debit_account
                customerList.push(emptyParty)
            }
        }
        return customerList
    }

    async download_registred_invoices(): Promise<void> {
        await this.command_dispatcher.dispatch('download.registered.invoices', {})
    }

    async reject_invoiceable(id: number, reject_comment: string): Promise<string> {
        let res = await this.command_dispatcher.dispatch('reject.invoice', { inv_id: id, comment: reject_comment })
        return res.output
    }

    async delete_selected_items(selected_ids: Array<number>): Promise<Object> {
        try{
            await this.command_dispatcher.dispatch('delete.static.invoices', { inv_ids: selected_ids })
            return true
        }
        catch(e){
            return false
        }
    }
    async pay_downloaded_invoice(id:number): Promise<string> {
        let res = await this.command_dispatcher.dispatch('pay.invoice', { inv_id: id })
        return res.output
    }

    async save_third(party:Party): Promise<{ status: string, message?: string|Party }> {
        let res = await this.command_dispatcher.dispatch('save.third', { third: party })
        return res.output
    }

    async save_company_as_party(party:Party): Promise<{ status: string, message?: string|Party }> {
        let res = await this.command_dispatcher.dispatch('save.company.as.party', { supplier: party })
        return res.output
    }

    async get_pdf_info(uuid:string) : Promise<Object> {
        let queryURL = `/e_invoice_to_pdf/?uuid=${uuid}`;
        let response = await axios.get(process.env.VUE_APP_API_ENDPOINT+queryURL, {})
        if (response) {
            return {
                'invoiceable': response.data.invoiceable? this.api_to_domain(response.data.invoiceable) : null,
                'configuration': response.data.configuration,
                'rectificative_e_invoice': response.data.rectificative_e_invoice? this.api_to_domain(response.data.rectificative_e_invoice) : null,
            }
        } else {
            return {
                'invoiceable': null,
                'configuration': null,
                'rectificative_e_invoice': null,
            }
        }
    }

    async get_pdf_info_by_id(invoiceable_id: String) : Promise<Object> {
        let res = await this.query_dispatcher.dispatch('invoice.info.for.pdf', {invoiceable_id: invoiceable_id})
        return{
            'invoiceable': res.invoiceable? this.api_to_domain(res.invoiceable) : null,
            'configuration': res.configuration,
            'rectificative_e_invoice': res.rectificative_e_invoice? this.api_to_domain(res.rectificative_e_invoice) : null,
        }
    }

    async company_has_active_einvoice_contract(company_id:Number): Promise<boolean> {        
        let res = await this.query_dispatcher.dispatch('check.user.has.active.envoice.contract', {company_id: company_id})
        if (res.company) {
            return res.company
        }
        else {
            return false;
        }
    }

    async massive_send_via_email(ids: Array<number>, email_template: EmailTemplate): Promise<any> {
        let args = { inv_ids: ids,  subject: email_template.subject, body: email_template.message }
        return await this.async_command_dispatcher.dispatch("massive.send.invoice.via.mail", args)
    }
}